import { useCallback, useEffect, useState } from 'react'
import { crud } from '@think-internet/zeus-frontend-package'
import { Project } from '../../types/Project'
import props from '../../redux/props'

const useLoadProject = (uuid?: string): Project => {
  const projectFeature = crud.use(props.PROJECT)
  const [project, setProject] = useState<Project>(null)

  const pull = useCallback(async () => {
    const project = await projectFeature.get({ uuid })
    if (!!uuid && project) {
      setProject(project)
    }
  }, [projectFeature, uuid])

  useEffect(() => {
    if (!project && !!uuid) pull()
  }, [project, pull, uuid])

  return project
}

export default useLoadProject
